module.exports = __webpack_public_path__ + "img/clouds.d5272ee8.svg";